import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    horizontalLine: {
        borderBottom: `1px solid ${theme.palette.corporateBO.buttonLineDivider}`,
        flexGrow: 1,
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "0 22px 22px 22px",
    },
    buttonContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "15px 0",
    },
    addClusterButton: {
        "&.MuiButtonBase-root": {
            color: theme.palette.info.main,
            fontWeight: 700,
            fontSize: "12px",
            fontFamily: "Source Sans 3",
        },
        gap: theme.spacing(2),
    },
    moreIcon: {
        color: theme.palette.info.main,
        fontWeight: 400,
    },
    addClusterButtonText: {
        fontSize: "12px !important",
    },
    cardContainer: {
        padding: theme.spacing(5),
        background: theme.palette.primary.main,
        gap: theme.spacing(4),
        boxShadow: "0px 2px 4px rgba(62, 93, 138, 0.2)",
    },
    noClusterMessage: {
        textAlign: "center",
    },
}));
